'use strict';

module.exports.Command = require('./command');
module.exports.CommandHandler = require('./handler');


//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/build/commands/index.js
// module id = b/Aa
// module chunks = 0